import React from "react";
import Skeleton from "react-loading-skeleton";
const NotificationsLoader = () => {
    const LoaderComponents = [];
    for (let i = 1; i <= 10; i++) {
        LoaderComponents.push(React.createElement("div", { className: `row mt-2`, key: i },
            React.createElement("div", { className: 'col-12' },
                React.createElement("div", { className: "timeline-label customNotificationDiv p-5 bg-white" },
                    React.createElement("div", { className: "timeline-item" },
                        React.createElement("div", { className: "d-flex flex-column" },
                            React.createElement("div", { className: "" },
                                React.createElement("div", { className: "timeline-badge" },
                                    React.createElement(Skeleton, { width: '22px', height: '22px' })))),
                        React.createElement("div", { className: "fw-mormal timeline-content ps-5" },
                            React.createElement("span", { className: 'fs-12 text-gray-600' },
                                "  ",
                                React.createElement(Skeleton, { height: '20px', width: '150px' })),
                            React.createElement("div", { className: "d-flex align-items-start   " },
                                React.createElement("div", { className: "p-2 mt-1 d-none" },
                                    React.createElement("i", { className: "fas fa-bolt fs-3" })),
                                React.createElement("div", { className: "p-2 w-100" },
                                    React.createElement(Skeleton, { width: '90%', height: '20px' }),
                                    React.createElement("div", { className: 'mt-4' },
                                        React.createElement("div", { className: "d-flex gap-1 " },
                                            React.createElement(Skeleton, { width: '70px', height: '100%' }),
                                            React.createElement(Skeleton, { width: '70px', height: '100%' }),
                                            " ",
                                            React.createElement(Skeleton, { width: '70px', height: '100%' })))))))))));
    }
    const loader = LoaderComponents.map((item) => {
        return item;
    });
    return (React.createElement(React.Fragment, null, loader));
};
export { NotificationsLoader };
